import { http } from "@/communication";

const permissionModule = {
  namespaced: true,
  state: {
    permissions: []
  },
  actions: {
    read({ dispatch, getters }) {
      if (!getters["all"].length) {
        return dispatch("forceLoad");
      }
    },
    forceLoad({ commit }) {
      return http
        .get("/api/v1/permission")
        .then(({ data }) => {
          commit("update", data);
        })
        .catch(error => {
          console.log("Permissions error", error);
        });
    }
  },
  mutations: {
    update(state, permissions) {
      state.permissions = permissions;
    }
  },
  getters: {
    all: state => state.permissions
  }
};

export default permissionModule;
